export default __webpack_public_path__ + "static/media/boite4.780c3c92.jpg";